import { Component, OnInit, Inject, signal, Optional } from '@angular/core';
import { DialogConfig, DialogRef } from '../../../core/factory/dialog/utils';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { INQUIRY_SUB_PREFIX } from '../../../core/data/constants';
import { env } from '../../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-inquiry-dialog',
  templateUrl: './inquiry-dialog.component.html',
  styleUrls: ['./inquiry-dialog.component.scss']
})
export class InquiryDialogComponent implements OnInit {
  apiEndpoint = env.apiURL + '/api/send-inquiry';
  inquiryForm!: FormGroup;
  statusMessage = '';
  showSpinner = false;
  submitted = false;
  successMessage = '';
  errorMessage = '';
  isLoading = false;
  showForm = false;

  constructor(
    public config: DialogConfig,
    public dialog: DialogRef,
    private http: HttpClient,
    private fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: any,
  ) {
    this.inquiryForm = this.fb.group({
      subject: ['', [Validators.required]],
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      phone: ['', [Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]],
      message: ['', [Validators.required, Validators.maxLength(500)]]
    }, {
      validators: this.atLeastOneContactMethodValidator
    });
  }

  ngOnInit(): void {
    console.log(this.config);
    console.log(this.dialog);
  }

  submitForm(): void { //inline-edit-access-btn
    this.submitted = true;
    this.successMessage = '';
    this.errorMessage = '';

    if (this.inquiryForm.invalid) return;

    this.statusMessage = '';
    this.showSpinner = true;
    this.isLoading = true;

    const payload = { ...this.inquiryForm.value };
    console.log(payload);

    this.http.post(this.apiEndpoint, payload).subscribe({
      next: () => {
        this.successMessage = 'Your inquiry has been sent';
        this.inquiryForm.reset();
        this.submitted = false;
        setTimeout(() => this.dialog.close
          ({
            data: { ...this.inquiryForm.value },
            message: 'submitted',
            action: 'confirm'
          }), 1000);
      },
      error: () => {
        this.errorMessage = 'Something went wrong - please try again later.';
      },
      complete: () => this.isLoading = false,
    });
  }

  onCancel() {
    this.dialog.close({
      action: 'cancel',
      message: 'confirm dialog closed',
    });
  }

  onClose() {
    this.dialog.close({
      action: 'confirm',
      message: 'confirm dialog closed',
    });
  }

  atLeastOneContactMethodValidator(form: FormGroup) {
    const phone = form.get('phone')?.value;
    const email = form.get('email')?.value;
    return phone || email ? null : { contactRequired: true };
  }

  formatPhone(value: string): string {
    const digits = value.replace(/\D/g, '').slice(0, 10);
    return digits.replace(/(\d{3})(\d{3})(\d{0,4})/, (_, a, b, c) => `${a}-${b}-${c}`.replace(/-$/, ''));
  }
}
